export const listMenuNavigation = [
    {
        title: '',
        path: '/',
        icon: 'home.png',
        step: '/',
    },
    {
        title: 'Lucky 5/90',
        path: '/games-loto?loto=loto-5-90',
        icon: 'loto-turbo.png',
        step: 1,
    },
    {
        title: 'Lucky 6/45',
        path: '/games-loto?loto=loto-6-45',
        icon: 'loto-nap.png',
        step: 2,
    },
    {
        title: 'Lucky 4/59',
        path: '/games-loto?loto=loto-4-59-luckia',
        icon: 'loto-nap.png',
        step: 3,
    },
    {
        title: 'Lucky 5/45',
        path: '/games-loto?loto=loto-5-45',
        icon: 'loto-nap.png',
        step: 4,
    },
    {
        title: 'HISTORY',
        path: '/history',
        icon: 'history.png',
        step: '/history',
    },
    {
        title: 'Résultats Direct',
        path: '/live-results',
        icon: 'loto-turbo.png',
        step: '/live-results',
    },
    // {
    //     title: 'Results (Raffle)',
    //     path: '/raffle-results',
    //     icon: 'history.png',
    //     step: '/raffle-results',
    // },
]
